import { useCallback, useEffect, useRef, useState } from 'react';

export const useProgressTimer = (step = 1, interval = 150) => {
  const [progress, setProgress] = useState(0);
  const progressIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const stopProgress = useCallback(() => {
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
      progressIntervalRef.current = null;
    }
  }, []);

  const startProgress = useCallback(
    (maxProgress: number, initialProgress?: number) => {
      stopProgress();
      if (initialProgress !== undefined) {
        setProgress(initialProgress);
      }
      progressIntervalRef.current = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = Math.min(prevProgress + step, maxProgress);
          if (newProgress >= maxProgress) {
            stopProgress();
          }
          return newProgress;
        });
      }, interval);
    },
    [interval, step, stopProgress],
  );

  const resetProgress = useCallback(() => {
    stopProgress();
    setProgress(0);
  }, [stopProgress]);

  useEffect(() => stopProgress, [stopProgress]);

  return {
    progress,
    resetProgress,
    setProgress,
    startProgress,
    stopProgress,
  };
};
